// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Ihf-P","sectionTitle":"styles_sectionTitle__DLklF"};